import React from 'react';

const VideoIcon = ({ size = 32, color = '#ffb74d', style = {} }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <rect x="3" y="6" width="15" height="12" rx="2" fill={color} />
    <polygon points="10,10 15,13 10,16" fill="#fff" />
    <rect x="19" y="9" width="2" height="6" rx="1" fill={color} stroke="#fff" strokeWidth="1.5" />
  </svg>
);

export default VideoIcon; 